<i18n src='@/locale/login-localization.json'></i18n>

<template>
    <v-card
        max-width="380px"
        class="pa-6"
    >
        <v-form
            ref="loginForm"
            lazy-validation
        >
            <v-tabs class="mb-4" centered v-model="auth_type">
                <v-tab v-if="showTab('Local')">{{ $t("LocalAuthentication") }}</v-tab>
                <v-tab v-if="showTab('Ldap')">{{ $t("LdapAuthentication") }}</v-tab>
            </v-tabs>
            <v-text-field
                v-model="loginData.username"
                :label="$t('Username')"
                :rules="loginRules"
                required
                outlined
                dense
                @keydown.enter.prevent="login"
                autofocus
                @input="clearError"
            ></v-text-field>
            <v-text-field
                v-model="loginData.password"
                :label="$t('Password')"
                :rules="loginRules"
                type="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                required
                outlined
                dense
                @keydown.enter.prevent="login"
                @click:append="showPassword = !showPassword"
                @input="clearError"
            ></v-text-field>
            <v-card-text v-if="capsLock" class="pa-0 mt-n1" style="color: orange !important; font-weight: bold;">
                Caps Lock
            </v-card-text>
            <a class="mb-4 mt-1 d-block text-center body-2 mx-auto grey--text text--darken-3"
                   href="/restore-password.html"
                   v-show="auth_type === 0"
            >
                პაროლის აღდგენა
            </a>
            <v-btn
                color="primary"
                block
                @click="login"
            >
                {{ $t('Login') }}
            </v-btn>
            <v-card-text class="error--text pb-0" v-show="showError">
                არასწორი მომხმარებელი ან პაროლი
            </v-card-text>
        </v-form>
    </v-card>
</template>

<script>
import signInService from "@/service/signIn-service";
import globalDataService from "@/script/global-data-service";
import { eventBus } from "@/script/global-emit/eventBus";

export default {
    name: "signInForm",
    data() {
        return {
            loginData: {
                username: null,
                password: null,
                auth_type: null
            },
            loginRules: [v => !!v || "შევასება აუცილებელია"],
            auth_type: null,
            showPassword: false,
            returnUrl: null,
            showError: false,
            authTypes: ['Local'],
            capsLock: false
        }
    },
    mounted() {
        this.returnUrl = new URLSearchParams(location.search).get('returnUrl')
        eventBus.$on("LoginedOnSignInPage", () => {
            // if user is Logined and has returnUrl
            if(this.$store.state.IsAuthenticated) {
                this.redirectToFirstPage();
            }
        });
        this.getAuthTypes();
        //    listeners
        window.addEventListener('click', this.detectCapsLock);
        document.addEventListener('keydown', this.detectCapsLock);
    },
    methods: {
        login() {
            if (this.$refs.loginForm.validate()) { // Validation
                signInService.signIn(this.loginData).then((res) => {
                    if (res.ok) {
                        globalDataService.setGlobalData().then(() => {
                            // this.$emit("loginSuccess")

                            this.redirectToFirstPage();
                        })
                    } else {
                        this.showError = true;
                    }
                });
            }
        },
        clearError() {
            if (this.showError) this.showError = false
        },
        getLastOpenedUrl(userId) {
            if (userId && localStorage.users) {
                let users = JSON.parse(localStorage.users);
                if (users[userId] && users[userId]["lastOpenedUrl"] && users[userId]["lastOpenedUrl"] !== "/signIn" && users[userId]["lastOpenedUrl"] !== "/signIn.html") {
                    return users[userId]["lastOpenedUrl"];
                }
            }
            return null;
        },
        redirectToFirstPage() {
            let lastOpenedUrl = this.getLastOpenedUrl(this.$store.state.PersonCode);
            location.assign(this.returnUrl || lastOpenedUrl || "/");
        },
        getAuthTypes() {
            signInService.getSettings().then(res => {
                if (res.AuthTypes && res.AuthTypes.length) {
                    this.authTypes = res.AuthTypes;
                }
            })
        },
        showTab(val) {
            return this.authTypes.includes(val);
        },
        detectCapsLock(event) {
            let caps = event.getModifierState && event.getModifierState('CapsLock');
            this.capsLock = caps;
        }
    },
    watch: {
        auth_type(val) {
            this.loginData.auth_type = val + 1;
        }
    }
}
</script>

<style scoped>

</style>
